module.exports = __webpack_public_path__ + "img/paygo-img.8cf14307.png";